import { ArticleFlat, Permission, RootState } from 'types'
import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { useModals } from 'almanac-ui/Modal'
import { useEffect } from 'react'
import qs from 'qs'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { ShareSheet } from 'components/ShareSheet/ShareSheet'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { useLocation } from 'react-router-dom'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { reportError } from 'utils/error'

export function useAccessRequestLocationHandler(article: ArticleFlat, enabled: boolean = true) {
  const auth = useSelector(({ auth }: RootState) => auth, isEqual)
  const { openModal: openNewShareModal } = useModals()
  const location = useLocation()

  useEffect(() => {
    if (!enabled) {
      return
    }

    const params = qs.parse(location.search, { ignoreQueryPrefix: true })

    if (params.access_request && auth) {
      const permission = params.edit ? Permission.Edit : Permission.Read
      client.acceptAccessRequest(params.access_request, permission).then((res) => {
        if (res.type === SUCCESS_RESPONSE_TYPE) {
          showToastMessage('Access was granted! 🎉', 'success')

          openNewShareModal(ShareSheet, {
            file: {
              id: article.id,
              type: 'article',
            },
          })
        } else {
          showErrorMessageToast('Something went wrong while adding access to the document, please try again later.')
          reportError('Failed to add access via link', {
            severity: 'error',
            metaData: { response: res, auth },
          })
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, article.id, enabled])
}
